import { CustomFields } from "@web-app/components";
import { CustomField, CustomFieldValue } from "@web-app/types";

interface AdditionalDetailsTabProps {
  currentWorkspaceId: string;
  customFieldsState?: Array<{
    definition: CustomField;
    values: CustomFieldValue[];
  }>;
  setCustomFields: React.Dispatch<
    React.SetStateAction<
      Array<{ definition: CustomField; values: CustomFieldValue[] }>
    >
  >;
}

export function AdditionalDetailsTab({
  customFieldsState = [],
  currentWorkspaceId,
  setCustomFields,
}: AdditionalDetailsTabProps) {
  const handleCustomFieldsChange = (
    _fieldId: string,
    customField: CustomField,
    value: CustomFieldValue[],
  ) => {
    const existingCustomFieldIndex = (customFieldsState || []).findIndex(
      (cf) => cf.definition.id === customField.id,
    );

    const updatedCustomFields = structuredClone(customFieldsState);

    if (existingCustomFieldIndex > -1) {
      updatedCustomFields[existingCustomFieldIndex] = {
        definition: customField,
        values: value,
      };
    } else {
      updatedCustomFields.push({
        definition: customField,
        values: value,
      });
    }

    setCustomFields(updatedCustomFields);
  };

  return (
    <div className="">
      <CustomFields
        entity="order"
        workspaceId={currentWorkspaceId}
        onChange={handleCustomFieldsChange}
        customFieldsState={customFieldsState}
      />
    </div>
  );
}
